import React from "react";
import { Modal, Form, Input, message } from "antd";
import { useMutation } from "@apollo/client";
import { CREATE_GROUP_COUPON } from "./requests";

interface CreateGroupCouponProps {
  showGroupModal: boolean;
  setShowGroupModal: (visible: boolean) => void;
  refetch: () => void;
  isCreateView: boolean;
  selectedGroups: string[];
  setSelectedGroups: (id: string[]) => void;
}

const CreateGroupCoupon: React.FC<CreateGroupCouponProps> = ({
  showGroupModal,
  setShowGroupModal,
  refetch,
  isCreateView,
  selectedGroups,
  setSelectedGroups,
}) => {
  const [form] = Form.useForm();
  const [createGroupCoupon, { loading }] = useMutation(CREATE_GROUP_COUPON);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const { data } = await createGroupCoupon({ variables: { groupCoupon: { group:values.group },
      } });

      if (data) {
        message.success("Grupo creado exitosamente");
        await refetch();
        if(!isCreateView){
          setSelectedGroups([...selectedGroups, data.createGroupCoupon.groupCoupon.id])
        }
        onClose();
      }
    } catch (error) {
      console.log(error)
      message.error("Error al crear el grupo");
    }
  };

  const onClose = ()=>{
    setShowGroupModal(false);
    form.resetFields();
  }

  return (
    <Modal
      title="Crear Nuevo Grupo"
      open={showGroupModal}
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="group"
          label="Nombre del Grupo"
          rules={[{ required: true,
            message: "Por favor ingrese un nombre" }]}
        >
          <Input placeholder="Ingrese el nombre del grupo" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateGroupCoupon;
